import { IAttachment } from '../../notes/generic-notes/attachments/IAttachment';

export enum IFeeling {
    VeryGood = 1,
    Good = 2,
    Neutral = 3,
    Bad = 4,
    VeryBad = 5
};

export enum IEnergy {
    Low = 25,
    Medium = 50,
    High = 75,
    VeryHigh = 100
};

export enum IPersonalTime {
    Low = 1, // 0-30 mins
    Medium = 2, // 30-60 mins
    High = 3, // 1-3 hrs
    VeryHigh = 4 // 3+ hrs
};

export const PERSONAL_TIME_LABELS: {[time in IPersonalTime]: string} = {
    1: '0-30m',
    2: '30-60m',
    3: '1-3 hrs',
    4: '3+ hrs'
};

export type IEmotion =
    'happy' |
    'excited' |
    'proud' |
    'appreciated' |
    'grateful' |
    'sad' |
    'angry' |
    'lonely' |
    'overwhelmed' |
    'stressed' |
    'afraid' |
    'calm' |
    'exhausted' |
    'frustrated' |
    'guilty' |
    'indifferent';

export type ILifeEvent =
    'good sleep' |
    'bad sleep' |
    'ok sleep' |
    'exercise' |
    'outside time' |
    'personal time' |
    'social time' |
    'drink water' |
    'breakfast' |
    'lunch' |
    'dinner' |
    'snacks';

export type ICareEvent =
    'personal care' |
    'meal prep' |
    'appointment' |
    'meeting' |
    'achievement' |
    'medication' |
    'exercise' |
    'social activity' |
    'cleaning' |
    'groceries' |
    'transport' |
    'incident' |
    'home visit' |
    'respite care' |
    'new routine' |
    'emergency';

export type ICheckinTag =
    IEmotion |
    ILifeEvent |
    ICareEvent;

export type ICheckinType = 'personal' | 'care';

interface IBaseCheckin {
    checkinType: ICheckinType;
    noteId: string;
    timestamp: string;
    note: string;
    attachments: IAttachment[],
    tags?: string[];
}

export interface IPersonalCheckin extends IBaseCheckin {
    checkinType: 'personal';
    feeling?: IFeeling;
    energy?: IEnergy;
    personalTime?: IPersonalTime;
    emotions?: IEmotion[];
    lifeEvents?: ILifeEvent[];
};

export type ICareEventHours = { [event in ICareEvent]?: number };

export interface ICareCheckin extends IBaseCheckin {
    checkinType: 'care';
    feeling?: IFeeling;
    emotions?: IEmotion[];
    lifeEvents?: ILifeEvent[];
    energy?: IEnergy;
    careEvents?: ICareEvent[];
    careEventHours?: ICareEventHours;
    totalCareHours?: number;
    totalCareHoursLocked?: boolean;
    milesDriven?: number;
    adjustedCareEvents?: ICareEvent[];
};

export type ICheckin = IPersonalCheckin | ICareCheckin;

export type INarrowedCheckin<T extends ICheckinType> =
    T extends 'personal' ? IPersonalCheckin :
    T extends 'care' ? ICareCheckin :
    never;
